import { Toaster } from "react-hot-toast";
import { Colors } from "@/constants";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { ms } from "@/ui/moderateScale";
import { getPlatform } from "@/models/platform";
import { useUISlice } from "./useUISlice";

export const useToast = () => {
  const ToastContainer = () => {
    useEffect(() => {
      return () => {
        // Clear all toasts when component unmounts
        toast.dismiss();
      };
    }, []);
    const isAndroid = getPlatform() === "android";
    const isIOS = getPlatform() === "ios";
    const insets = useUISlice((state) => state.device.safeArea);

    return (
      <Toaster
        containerStyle={{
          ...(isAndroid && {
            top: ms(24),
            marginTop: ms(24),
          }),
          ...(isIOS && {
            top: insets.top + ms(12),
          }),
        }}
        toastOptions={{
          style: { fontFamily: "sans-serif", color: Colors.text },
        }}
      />
    );
  };

  return {
    toast,
    ToastContainer,
  };
};
